import React from 'react';
import { BrandContext } from '@zg-rentals/multibrand-ui/lib/BrandContext';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import SpacerRow from '@zg-rentals/multibrand-ui/lib/SpacerRow';
import Link from '@zg-rentals/multibrand-ui/lib/Link';

import StringConstants from '@common/constants/StringConstants';
import withContext from '../../../../shared/utils/withContext';

class ContactSupport extends React.Component<{ brandContext: BrandContext }> {
  render() {
    const {
      brandContext: { brand },
    } = this.props;
    const supportEmail = StringConstants.LINKS.SUPPORT_EMAIL[brand];
    const faqLink = `${StringConstants.LINKS.FAQ_PAGE.zrm}?utm_campaign=landlord_payments_faq`;

    return (
      <>
        <SpacerRow size="sm" />
        <Text type="body-small" emphasize inline>
          <Link href={faqLink} target="_blank">
            Common Questions
          </Link>
        </Text>
        <SpacerRow size="sm" />
        <Text type="body-small" emphasize inline>
          <Link href={`mailto:${supportEmail}`}>Email Us</Link>
        </Text>
      </>
    );
  }
}

export default withContext(ContactSupport, BrandContext, 'brandContext');
